const weapons = [
   { name: "Clarinet", imageResource: "https://terror-prom-media.s3.amazonaws.com/weapon-images/clarinet.webp" },
   { name: "Booze", imageResource: "https://terror-prom-media.s3.amazonaws.com/weapon-images/booze.webp" },
   { name: "Sloppy Joe", imageResource: "https://terror-prom-media.s3.amazonaws.com/weapon-images/sloppy_joe.webp" },
   { name: "Stapler", imageResource: "https://terror-prom-media.s3.amazonaws.com/weapon-images/stapler.webp" },
   { name: "Clipboard", imageResource: "https://terror-prom-media.s3.amazonaws.com/weapon-images/clipboard.webp" },
   { name: "Knife", imageResource: "https://terror-prom-media.s3.amazonaws.com/weapon-images/knife.webp" },
];

export default weapons;
